import { useSelector, useDispatch } from "react-redux";
import useFetch from "../../utils/useFetch";
import { setList, setDetail } from "./store";

const useContests = () => {
  const { list, detail } = useSelector((state) => state.contests);
  const dispatch = useDispatch();
  const { get, post, put, del } = useFetch();

  const endpoint = "contests";
  const endpointParticipants = "contest-participants";

  const fetchList = async () => {
    const response = await get({
      endpoint,
      isPrivate: true,
    });
    response && dispatch(setList(response));
  };

  const fetchDetail = async (id) => {
    const response = await get({ endpoint: `${endpoint}/${id}`, isPrivate: true, });
    dispatch(setDetail(response));
  };

  const updateDetail = async (id, body) => {
    const response = await put({
      endpoint,
      id,
      body,
    });
    response && dispatch(setDetail(response));
  };

  const createContest = async (data) => {
    return await post({
      endpoint,
      body: data,
    });
  };

  const addParticipant = async (data) => {
    console.log(data);
    return await post({
      endpoint: endpointParticipants,
      body: data,
    });
  };

  const fetchParticipants = async (contestId) => {
    const response = await get({
      endpoint: `${endpointParticipants}`,
      isPrivate: true,
      params: {
        contest: contestId,
      },
    });
    response && dispatch(setDetail({ ...detail, participants: response }));
  };

  const deleteParticipant = async (id) => {
    return await del({
      endpoint: `${endpointParticipants}`,
      id,
      isPrivate: true,
    });
  };

  const getRestaurantParticipants = async (restaurantId) => {
    const response = await get({
      endpoint: `${endpointParticipants}/current-participants`,
      isPrivate: true,
      params: { restaurant: restaurantId },
    });
    return response;
  };


  return {
    contestList: list,
    contest: detail,
    fetchContestList: fetchList,
    fetchContest: fetchDetail,
    setContest: (contest) => dispatch(setDetail(contest)),
    clearContest: () => dispatch(setDetail({})),
    updateContest: updateDetail,
    createContest,
    addParticipant,
    fetchParticipants: fetchParticipants,
    deleteParticipant,
    getRestaurantParticipants,
  };
};

export default useContests;
